class AlgoliaHitVariantSizes extends HTMLElement {
  constructor() {
    super();
    this.render = this.render.bind(this);
  }
  /**
   * Renders the wrapper content.
   * @returns {string} The rendered content HTML.
   */
  render() {
    const wrapperDiv = document.createElement('div');
    wrapperDiv.classList.add('algolia-hit-variant-sizes');
    const sizeContainer = document.createElement('span');
    sizeContainer.innerText = 'Size: '
    wrapperDiv.appendChild(sizeContainer);
    wrapperDiv.renderSizes = this.renderSizes;
    wrapperDiv.populateSizes = this.populateSizes;
    return wrapperDiv;
  }  

  /**
   * Used to populate the size display on algolia hit cards
   * It appends all the sizes to a maximum of 2 rows, adding text to denote the 
   * number of undisplayed sizes if it overflows further
   * @param {*} sizes 
   */
  populateSizes(sizes) {
    const container = this;
    // Clear previous content, used for updating the displayed text 
    // when mousing over or clicking a different color
    container.innerHTML = ''; 

    // Create the lines that will display the size text.
    const line1 = document.createElement('span');
    const line2 = document.createElement('span');
    line1.className = 'algolia-hit-variant-size-text';
    line2.className = 'algolia-hit-variant-size-text';
    container.appendChild(line1);
    container.appendChild(line2);

    // Temporary span for measuring the width of spans to determine if text should be added or removed
    const tempSpan = document.createElement('span');
    tempSpan.style.visibility = 'hidden';
    tempSpan.style.position = 'absolute';
    tempSpan.style.whiteSpace = 'nowrap';
    tempSpan.style.fontSize = getComputedStyle(container).fontSize;
    tempSpan.style.fontFamily = getComputedStyle(container).fontFamily;
    document.body.appendChild(tempSpan);

    // Calculate available width (container width minus horizontal margins)
    const containerStyles = getComputedStyle(container);
    const marginLeft = parseFloat(containerStyles.marginLeft) || 0;
    const marginRight = parseFloat(containerStyles.marginRight) || 0;
    const usableWidth = container.offsetWidth - marginLeft - marginRight;

    let line1Text = 'Sizes: ';
    let line2Text = '';
    let i = 0;

    // Fill line 1
    while (i < sizes?.length) {
      const nextText = line1Text + sizes[i] + ', ';
      tempSpan.textContent = nextText;
      if (tempSpan.offsetWidth <= usableWidth) {
        line1Text = nextText;
        i++;
      } else {
        break;
      }
    }

    // Fill line 2
    while (i < sizes?.length) {
      const nextText = line2Text + sizes[i] + ', ';
      tempSpan.textContent = nextText;
      if (tempSpan.offsetWidth <= usableWidth) {
        line2Text = nextText;
        i++;
      } else {
        break;
      }
    }

    // If sizes remain, add "+n more"
    const remaining = sizes?.length - i;
    if (remaining > 0) {
      let moreText = `+${remaining}\u00A0more`;
      tempSpan.textContent = line2Text + moreText;
      while (tempSpan.offsetWidth > usableWidth && i > 0) {
        i--;
        const lastComma = line2Text.lastIndexOf(',', line2Text.length - 3);
        line2Text = line2Text.slice(0, lastComma + 1);
        moreText = `+${sizes.length - i}\u00A0more`;
        tempSpan.textContent = line2Text + moreText;
      }
      line2.textContent = line2Text.trim().replace(/,\s*$/, '') + ' ' + moreText;
    } else {
      line2.textContent = line2Text.trim().replace(/,\s*$/, '');
    }

    line1.textContent = line1Text.trim().replace(/,\s*$/, '');
    document.body.removeChild(tempSpan);
  }


}

customElements.define("algolia-hit-variant-sizes", AlgoliaHitVariantSizes);
